import { NgModule } from '@angular/core';
import { PageMetaService } from '@shared/shared-meta/page-meta.service';

@NgModule({
  providers: [PageMetaService]
})
export class SharedMetaModule {
}
